import { AbstractControl } from '@angular/forms';

export const callLengthMatcher = (control: AbstractControl): { [key: string]: boolean } => {
  const fromMin = control.get('from').get('fromMin');
  const fromSec = control.get('from').get('fromSec');
  const toMin = control.get('to').get('toMin');
  const toSec = control.get('to').get('toSec');

  const minLengthSeconds = fromMin.value * 60 + fromSec.value;
  const maxLengthSeconds = toMin.value * 60 + toSec.value;

  if (!fromSec || !fromMin || !toMin || !toSec) {
    return null;
  }

  return maxLengthSeconds < minLengthSeconds ? { nomatch: true } : null;
};
